var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#73CF9D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4994,
    cy: 49.9998,
    r: 33.3333,
    fill: "#73CF9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8164 40.7258C62.4155 40.7377 62.0349 40.9053 61.7554 41.193L45.8712 57.0772L40.7895 51.9954C40.6473 51.8473 40.477 51.7291 40.2885 51.6476C40.1 51.5662 39.8972 51.5231 39.6919 51.521C39.4866 51.5189 39.2829 51.5578 39.0928 51.6354C38.9027 51.7131 38.73 51.8278 38.5849 51.973C38.4397 52.1182 38.3249 52.2909 38.2473 52.481C38.1697 52.671 38.1308 52.8747 38.1329 53.08C38.135 53.2853 38.178 53.4882 38.2595 53.6766C38.3409 53.8651 38.4592 54.0354 38.6073 54.1776L44.7801 60.3505C45.0695 60.6398 45.462 60.8023 45.8712 60.8023C46.2804 60.8023 46.6729 60.6398 46.9623 60.3505L63.9376 43.3751C64.1606 43.1584 64.3129 42.8793 64.3746 42.5745C64.4363 42.2697 64.4044 41.9533 64.2832 41.6669C64.162 41.3806 63.9571 41.1374 63.6954 40.9695C63.4336 40.8016 63.1272 40.7166 62.8164 40.7258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d2a384659815f33c4552c67d85e97976.svg";
export { ForwardRef as ReactComponent };